import { ServicePageTemplate } from "@/components/services/ServicePageTemplate";
import { servicePages } from "@/data/servicePages";

const data = servicePages.find((s) => s.slug === "workmens-compensation")!;
const WorkmensCompensation = () => <ServicePageTemplate data={data} />;
export default WorkmensCompensation;
